<template>
  <div class="ls-app" :class="{ 'ls-guest': !user.loggedIn }">
    <!-- ============ SIDEBAR ============ -->
    <aside class="ls-side" :class="{ 'ls-open': menuOpen }">
      <div class="ls-brand">
        <div class="ls-mark">Ls</div>
        <div class="ls-brandtext">
          <h1>Leerlingensync</h1>
          <p>SGFV · Informat&nbsp;→&nbsp;Workspace</p>
        </div>
        <button class="ls-hamburger" @click="menuOpen = !menuOpen" aria-label="Menu">
          <span class="material-icons">{{ menuOpen ? 'close' : 'menu' }}</span>
        </button>
      </div>

      <div class="ls-navcols" v-if="user.loggedIn" @click="menuOpen = false">
        <nav class="ls-navgroup">
          <h2>Overzicht</h2>
          <router-link class="ls-navlink" to="/"><span class="material-icons ic">home</span> Home</router-link>
          <router-link class="ls-navlink" to="/info"><span class="material-icons ic">info</span> Info</router-link>
          <router-link class="ls-navlink" to="/hoehetwerkt"><span class="material-icons ic">schema</span> Hoe de tool werkt</router-link>
          <router-link v-if="isSuper" class="ls-navlink" to="/manualsync"><span class="material-icons ic">cloud_sync</span> Manuele synchronisatie</router-link>
        </nav>

        <nav class="ls-navgroup" v-if="isSuper">
          <h2>Monitoring</h2>
          <router-link class="ls-navlink" to="/joboverview"><span class="material-icons ic">task</span> Jobs</router-link>
          <router-link class="ls-navlink" to="/erroroverview"><span class="material-icons ic">report</span> Fouten</router-link>
          <router-link class="ls-navlink" to="/cronjoberroroverview"><span class="material-icons ic">terminal</span> Cronjob-fouten</router-link>
          <router-link class="ls-navlink" to="/dubbeleaccounts">
            <span class="material-icons ic">group</span> Dubbele accounts
            <span
              v-if="botsingen.aandachtspunten"
              class="ls-navdot"
              :class="{ 'ls-navdot-warn': !botsingen.actie }"
              :title="botsingDotTitel"
            ></span>
          </router-link>
        </nav>

        <nav class="ls-navgroup">
          <h2>Beheer</h2>
          <router-link class="ls-navlink" to="/students"><span class="material-icons ic">storage</span> Leerlingen</router-link>
          <router-link v-if="isSuper" class="ls-navlink" to="/gmailonlyorgs"><span class="material-icons ic">no_accounts</span> Gmail-only OU's</router-link>
          <router-link v-if="isSuper" class="ls-navlink" to="/workspaceglobals"><span class="material-icons ic">ballot</span> Workspace-situatie</router-link>
          <router-link v-if="isSuper" class="ls-navlink" to="/usermanagement"><span class="material-icons ic">manage_accounts</span> Gebruikers</router-link>
        </nav>
      </div>

      <div class="ls-side-foot">
        <span>Leerlingensync · console</span>
        <span class="ls-mono">{{ nu }}</span>
      </div>
    </aside>

    <!-- ============ MAIN ============ -->
    <div class="ls-main">
      <header class="ls-topbar">
        <button class="ls-hamburger ls-topham" @click="menuOpen = !menuOpen" aria-label="Menu">
          <span class="material-icons">menu</span>
        </button>
        <form v-if="user.loggedIn" class="ls-topsearch" @submit.prevent="doSearch">
          <span class="material-icons">search</span>
          <input v-model="globalSearch" placeholder="Zoek een leerling…" aria-label="Zoek een leerling" />
        </form>
        <div class="ls-spacer"></div>
        <div class="ls-user" v-if="user.loggedIn">
          <img v-if="user.data && user.data.photoURL" :src="user.data.photoURL" class="ls-avatar" alt="" referrerpolicy="no-referrer" />
          <div v-else class="ls-avatar ls-avatar-init">{{ initials }}</div>
          <div class="ls-who">
            <b>{{ displayName }}</b>
            <span>{{ roleLabel }}</span>
          </div>
          <router-link to="/login" class="ls-btn ls-ghost ls-sm" @click.native="logout">
            <span class="material-icons" style="font-size:16px">logout</span> Afmelden
          </router-link>
        </div>
        <router-link v-else to="/login" class="ls-btn ls-primary ls-sm">
          <span class="material-icons" style="font-size:16px">login</span> Aanmelden
        </router-link>
      </header>

      <main class="ls-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      menuOpen: false,
      globalSearch: '',
      nu: new Date().toLocaleString('nl-BE', { dateStyle: 'short', timeStyle: 'short' })
    }
  },
  computed: {
    ...mapGetters({ user: 'user', botsingen: 'accountBotsingen' }),
    botsingDotTitel () {
      const stukken = []
      if (this.botsingen.actie) { stukken.push(this.botsingen.actie + ' botsing(en) die actie vragen') }
      if (this.botsingen.opvolgen) { stukken.push(this.botsingen.opvolgen + ' op te volgen') }
      return stukken.join(' · ')
    },
    isSuper () {
      return !!(this.user && this.user.claims && this.user.claims.superuser)
    },
    displayName () {
      const d = this.user && this.user.data
      return (d && (d.displayName || d.email)) || 'Beheerder'
    },
    initials () {
      const n = this.displayName.trim()
      const parts = n.split(/[\s@.]+/).filter(Boolean)
      const chars = (parts[0] || '').charAt(0) + (parts[1] || '').charAt(0)
      return (chars || n.charAt(0)).toUpperCase()
    },
    roleLabel () {
      return this.isSuper ? 'Superuser' : 'Beheerder'
    }
  },
  methods: {
    doSearch () {
      const q = this.globalSearch.trim()
      if (!q) { return }
      this.$router.push({ path: '/students', query: { q, scope: 'ALL' } }).catch(() => {})
      this.globalSearch = ''
      this.menuOpen = false
    },
    async logout () {
      try { await this.$store.dispatch('logout') } catch (e) { console.log(e) }
    }
  }
}
</script>

<style lang="scss">
/* ---- app grid ---- */
.ls-app {
  display: grid;
  grid-template-columns: 252px 1fr;
  min-height: 100vh;
}

/* ---- sidebar ---- */
.ls-side {
  background: var(--ls-primary);
  color: var(--ls-primary-ink);
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
}
.ls-brand { display: flex; gap: 12px; align-items: center; padding: 18px 18px 16px; }
.ls-mark { width: 38px; height: 38px; border-radius: 9px; background: var(--ls-accent); color: var(--ls-accent-ink); display: grid; place-items: center; font-family: var(--ls-sans); font-weight: 700; font-size: 17px; letter-spacing: -.5px; flex: none; }
.ls-brandtext h1 { font-family: var(--ls-sans); font-size: 15px; margin: 0; font-weight: 700; letter-spacing: -.2px; line-height: 1.15; color: #fff; }
.ls-brandtext p { margin: 2px 0 0; font-size: 11px; color: rgba(234,244,243,.6); }
.ls-hamburger { display: none; margin-left: auto; background: none; border: none; color: var(--ls-primary-ink); cursor: pointer; padding: 4px; }

.ls-navcols { padding: 4px 12px; overflow-y: auto; flex: 1; }
.ls-navgroup h2 { font-size: 10.5px; text-transform: uppercase; letter-spacing: .13em; color: rgba(234,244,243,.5); margin: 14px 8px 6px; font-weight: 700; }
.ls-navlink { display: flex; align-items: center; gap: 11px; padding: 8px 10px; border-radius: 8px; color: rgba(234,244,243,.82); text-decoration: none; font-size: 13.5px; font-weight: 500; position: relative; margin-bottom: 1px; }
.ls-navlink .ic { font-size: 18px; opacity: .85; }
.ls-navlink:hover { background: rgba(255,255,255,.07); color: #fff; }
.ls-navlink.router-link-exact-active,
.ls-navlink.router-link-active:not([href="/"]) { background: rgba(255,255,255,.11); color: #fff; font-weight: 600; }
.ls-navlink.router-link-exact-active::before { content: ""; position: absolute; left: -12px; top: 6px; bottom: 6px; width: 3px; border-radius: 0 3px 3px 0; background: var(--ls-accent); }

/* Rood bolletje: er staat iets open dat aandacht vraagt (bv. een dubbel account).
   Oranje als het enkel om opvolging gaat, rood zodra er echt actie nodig is. */
.ls-navdot { width: 8px; height: 8px; border-radius: 50%; background: #E5533D; margin-left: auto; flex: none; box-shadow: 0 0 0 3px rgba(229,83,61,.22); animation: ls-navpulse 2.2s ease-in-out infinite; }
.ls-navdot.ls-navdot-warn { background: #E8A33D; box-shadow: 0 0 0 3px rgba(232,163,61,.22); }
@keyframes ls-navpulse { 0%, 100% { opacity: 1; } 50% { opacity: .45; } }
.ls-side-foot { padding: 12px 18px; font-size: 11px; color: rgba(234,244,243,.5); border-top: 1px solid rgba(255,255,255,.08); display: flex; justify-content: space-between; gap: 8px; }

/* ---- main ---- */
.ls-main { display: flex; flex-direction: column; min-width: 0; }
.ls-topbar { display: flex; align-items: center; gap: 12px; padding: 12px 24px; border-bottom: 1px solid var(--ls-line); background: var(--ls-surface); position: sticky; top: 0; z-index: 5; min-height: 60px; }
.ls-topham { display: none; color: var(--ls-ink); }
.ls-topsearch { display: flex; align-items: center; gap: 8px; background: var(--ls-surface-2); border: 1px solid var(--ls-line); border-radius: 8px; padding: 7px 11px; min-width: 220px; max-width: 340px; flex: 1; }
.ls-topsearch:focus-within { border-color: var(--ls-primary); }
.ls-topsearch .material-icons { color: var(--ls-ink-3); font-size: 18px; }
.ls-topsearch input { border: none; outline: none; background: none; font: inherit; font-size: 13px; color: var(--ls-ink); width: 100%; }
.ls-spacer { flex: 1; }
.ls-user { display: flex; align-items: center; gap: 10px; }
.ls-avatar { width: 34px; height: 34px; border-radius: 50%; object-fit: cover; flex: none; }
.ls-avatar-init { background: linear-gradient(135deg, var(--ls-primary), var(--ls-accent)); color: #fff; display: grid; place-items: center; font-family: var(--ls-sans); font-weight: 700; font-size: 13px; }
.ls-who { line-height: 1.2; }
.ls-who b { font-size: 13px; font-weight: 600; display: block; color: var(--ls-ink); }
.ls-who span { font-size: 11px; color: var(--ls-accent); font-weight: 600; }
.ls-content { padding: 24px 28px 56px; max-width: 1200px; width: 100%; }

/* ---- responsive ---- */
@media (max-width: 880px) {
  .ls-app { grid-template-columns: 1fr; }
  .ls-side { position: sticky; height: auto; }
  .ls-hamburger { display: block; }
  .ls-navcols { display: none; }
  .ls-side.ls-open .ls-navcols { display: block; }
  .ls-side.ls-open { position: fixed; inset: 0 auto 0 0; width: 260px; height: 100vh; z-index: 40; box-shadow: 0 0 40px rgba(0,0,0,.4); }
  .ls-side-foot { display: none; }
  .ls-topham { display: block; }
  .ls-who span { display: none; }
  .ls-content { padding: 18px 16px 44px; }
  .ls-topbar { padding: 10px 16px; }
}

:disabled:hover { cursor: not-allowed; }
</style>
